<template>
  <div className="WxPayResultViewContainer bothCenter colFlex">
    <img src="https://cdn.waityou.online/5c1a4d4b-6ea3-3705-373d-373f223d0b0b.svg" style="width:60vw"/>
    <span style="color: #4f4f4f;font-size: 20px">支付成功</span>
    <nut-button type="primary"
                @click="gotoOrderView"
                style="margin-top:40px;width: 70vw">前往查看更多信息
    </nut-button>
  </div>
</template>

<script>
export default {
  name: "WxPayResultView",
  data() {
    return {
      outTradeNo: this.$route.query.out_trade_no,
    }
  },
  methods: {
    gotoOrderView() {
      var mchData = {
        action: 'jumpOut',
        jumpOutUrl: `https://zhixuein.com/sale/fill/info/${this.outTradeNo}`, //跳转的页面
      };
      const postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    },
    init() {
      //初始化小票
      let mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
        height:960,
      };
      let postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');

    }
  },
  mounted() {
    /** 点金小票的js，需要在head中引入 */
    let head = document.querySelector('head');
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js';
    head.appendChild(script);
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.WxPayResultViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  min-height: 480px;
}
</style>